module.exports = __webpack_public_path__ + "img/matr1x_fire_genesis_flame_test_key_terms_and_faq.82c9518c.png";